import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function ProProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="loading-spinner">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!user.has_pro_access) {
    return (
      <div className="mx-auto max-w-2xl px-6 lg:px-10 py-16" data-testid="pro-gate">
        <Card className="p-10 border-black/10 text-center">
          <div className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-amber-400/20 text-amber-700">
            <Lock className="h-6 w-6" />
          </div>
          <div className="eyebrow mt-6">Espace Pro</div>
          <h1 className="mt-2 font-display text-3xl font-bold tracking-tight">
            Réservé aux abonnés DoctoSpa Pro
          </h1>
          <p className="mt-4 text-sm text-muted-foreground max-w-md mx-auto leading-relaxed">
            Cet espace regroupe la documentation technique, les vues éclatées et
            la base de codes erreur pour les techniciens et installateurs.
          </p>
          <div className="mt-8 inline-flex flex-col sm:flex-row gap-3">
            <Button asChild className="rounded-full px-6 bg-slate-950 hover:bg-slate-900" data-testid="upgrade-to-pro-btn">
              <Link to="/pricing">Rejoindre DoctoSpa Pro · 49,90 €/mo</Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full px-6">
              <Link to="/dashboard">Retour au tableau de bord</Link>
            </Button>
          </div>
        </Card>
      </div>
    );
  }
  return children;
}
